<div class="grid-container full-height full v-pad">
  <div class="form-width">
    <div class="grid-x grid-margin-x">
      @if (isLoading$ | async) {
        <div class="cell large-12 text-center">
          Generating PDF Preview...
        </div>
      }
      @if (pdfAvailable) {
        <div class="cell large-12 text-right">
          <button (click)="download()" class="button">
            Download <svg-icon icon="icon-download" class="white"></svg-icon>
          </button>
          <a style="display:none" href="" target="_blank" #downloadLink rel="noopener noreferrer"></a>
        </div>
        <div class="cell large-6 text-align-left">
          <button (click)="previousPage()" class="button small" [disabled]="currentPage === 1">
            <svg-icon icon="icon-chevron-left" class="white small"></svg-icon> Previous
          </button>
        </div>
        <div class="cell large-6 text-align-right">
          <button (click)="nextPage()" class="button small" [disabled]="currentPage === totalPages">
            Next <svg-icon icon="icon-chevron-right" class="white small"></svg-icon>
          </button>
        </div>
		<div class="cell large-12 text-center">
			<ngx-extended-pdf-viewer [src]="pdfUrl" [textLayer]="true" [showAll]="false" [page]="currentPage" [showToolbar]="false" (pdfLoaded)="onLoadComplete($event)" class="display-block border-one-pixel-solid"></ngx-extended-pdf-viewer>
		</div>
      }
      @if (showError) {
        <div class="cell large-12 text-center">
          Unable to render the PDF.
        </div>
      }
      <div class="grid-x grid-margin-x">
        <div class="cell small-12">
          <upload-view-files #files [uniqueId]="'files'" [coInstanceId]="coInstanceId" [isSupplemental]="false" [componentLabel]="'Exhibits:'" [showFileList]="false" [isPadded]="false" (newFilesList)="savedFiles($event)"></upload-view-files>
        </div>
        @if (hasFileListing()) {
          <div class="file-list cell small-12">
            Uploaded Files To Merge Into Letter:
            <div class="margin-bottom">
              @for (fl of filesToShow; track fl) {
                <div class="uploaded-files">
                  <span class="file-name padding-left">{{fl.fileName}}</span>
                  @if (allowFileDeletion) {
                    <button type="button" class="minor-margin-right" attr.aria-label="Delete file'{{fl.fileName}}'"
                      (click)="deleteFile(fl)">
                      <svg-icon class="dark-gray" aria-hidden="true" icon="icon-trash"></svg-icon>
                    </button>
                  }
                  <button type="button" attr.aria-label="Download file'{{fl.fileName}}'" class="btn btn-success btn-xs" (click)="downloadFile(fl)">
                    <svg-icon title="Download File" icon="icon-download" class="dark-gray" aria-hidden="true"></svg-icon>
                  </button>
                </div>
              }
            </div>
          </div>
        }
        <div class="cell small-12">
          <upload-view-files #supplementalFiles [uniqueId]="'supplementalFiles'" [coInstanceId]="coInstanceId" [isSupplemental]="true" [componentLabel]="'Attach Supplemental Files'" [showFileList]="false" [isPadded]="false" (newFilesList)="savedSupplementalFiles($event)"></upload-view-files>
        </div>
        @if (hasSupplementalFileListing()) {
          <div class="file-list cell small-12">
            Uploaded Supplemental Files (Will not be merged into letter):
            <div class="margin-bottom">
              @for (fl of supplementalFilesToShow; track fl) {
                <div class="uploaded-files">
                  <span class="file-name padding-left">{{fl.fileName}}</span>
                  @if (allowFileDeletion) {
                    <button type="button" class="minor-margin-right" attr.aria-label="Delete file'{{fl.fileName}}'"
                      (click)="deleteFile(fl)">
                      <svg-icon class="dark-gray" aria-hidden="true" icon="icon-trash"></svg-icon>
                    </button>
                  }
                  <button type="button" attr.aria-label="Download file'{{fl.fileName}}'" class="btn btn-success btn-xs" (click)="downloadFile(fl)">
                    <svg-icon title="Download File" icon="icon-download" class="dark-gray" aria-hidden="true"></svg-icon>
                  </button>
                </div>
              }
            </div>
          </div>
        }
      </div>
      @if (displayGroupAssignment) {
        <div class="cell small-12"></div>
        <div class="user-form-max-width">
          <h2>Please Choose the group you wish to assign the next level of review to:</h2>
          <ng-select [(ngModel)]="selectedGroup" [items]="allGroups" bindLabel="displayName" placeholder=""></ng-select>
        </div>
      }
    </div>
  </div>
</div>


<button class="back-link vertical-middle" (click)="goToLetter()" type="button">
  <span aria-hidden="true" class="back-link-span">
    <svg-icon icon="icon-chevron-left" class="white" aria-hidden="true"></svg-icon>
  </span>
  <span>Previous</span>
</button>
<button class="next-link vertical-middle" (click)="submitCO()" type="button">
  <span>Send to Next Level</span>
  <span aria-hidden="true" class="next-link-span">
    <svg-icon icon="icon-chevron-right" class="white" aria-hidden="true"></svg-icon>
  </span>
</button>

